import { Paper } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { AdvITableItem } from "components/advertising/AdvTableBody";
import Select from "components/common/Select";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { REPORT_TYPE } from "./common";
import { listStyles } from "./styles";

function AdvTable({
    advertisers: propsAdv,
    filmReleaseId,
    advertisementTypes,
    toggleAdvertisingForm,
    onFilterByType,
    reportType,
    showAdvType,
    onRemoveFromReport,
}) {
    const classes = listStyles();
    const [type, setType] = useState(null);
    const advertisers = filmReleaseId ? propsAdv.filter((adv) => adv.filmRelease.id === filmReleaseId) : propsAdv;
    function onChangeExpanded() {}

    function handleTypeChange(_type) {
        setType(_type);
        onFilterByType(_type ? _type.value : null);
    }
    const classTable = reportType === REPORT_TYPE.ADV ? classes.tablePaper : classes.tablePaperLog;

    const table = (
        <Table className={classes.table} aria-labelledby="tableTitle" size={"small"} aria-label="enhanced table">
            <TableBody className={"stripe-table "}>
                {advertisers.map((adv) => {
                    return (
                        <AdvITableItem
                            showCompactForReport
                            showFilm={false}
                            showCompany={false}
                            hideActions={true}
                            key={adv.id}
                            id={adv.id}
                            adv={adv}
                            toggleAdvertisingForm={toggleAdvertisingForm}
                            onRemoveFromReport={onRemoveFromReport}
                            selected={false}
                            expandAllRows={false}
                            onChangeExpanded={onChangeExpanded}
                        />
                    );
                })}
            </TableBody>
        </Table>
    );
    if (reportType === REPORT_TYPE.LOG) {
        return table;
    }
    return (
        <React.Fragment>
            {showAdvType && (
                <Paper className={classes.tableHeaderPaper}>
                    <div style={{ width: 200 }}>
                        <Select
                            options={advertisementTypes}
                            placeholder={"Filter by Type"}
                            value={type}
                            defaultMenuPortalTarget
                            onChange={handleTypeChange}
                        />
                    </div>
                </Paper>
            )}
            <Paper className={classTable}>{table}</Paper>
        </React.Fragment>
    );
}

AdvTable.propTypes = {
    showAdvType: PropTypes.bool,
    onFilterByType: PropTypes.func,
    onRemoveFromReport: PropTypes.func,
    reportType: PropTypes.string,
    filmReleaseId: PropTypes.number,
    toggleAdvertisingForm: PropTypes.func,
    advertisementTypes: PropTypes.array,
    advertisers: PropTypes.array,
};

AdvTable.defaultPtops = {
    showAdvType: true,
};
export default AdvTable;
